import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SigningService } from '@app/certificates/signing/signing.service';
import { MatStepperModule } from '@angular/material/stepper';
import { MatExpansionModule } from '@angular/material/expansion';
import { SigningComponent } from '@app/certificates/signing/component/signing.component';
import { SharedModule } from '@app/shared/modules/shared.module';

@NgModule({
  imports: [
    SharedModule,
    TranslateModule,
    ReactiveFormsModule,
    MatStepperModule,
    MatExpansionModule
  ],
  declarations: [
    SigningComponent
  ],
  providers: [SigningService]
})
export class SigningModule { }
